import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const EyeOff: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 20, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={(+size * 15) / 20}
      viewBox="0 0 20 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 1.56348C6.17879 1.56348 2.71351 3.6541 0.15649 7.04982C-0.0521632 7.32803 -0.0521632 7.71669 0.15649 7.9949C2.71351 11.3947 6.17879 13.4853 10 13.4853C13.8212 13.4853 17.2865 11.3947 19.8435 7.99899C20.0522 7.72078 20.0522 7.33212 19.8435 7.05391C17.2865 3.6541 13.8212 1.56348 10 1.56348ZM10.2741 11.722C7.73755 11.8816 5.64284 9.79095 5.80239 7.25029C5.93331 5.15558 7.63118 3.45772 9.72589 3.3268C12.2625 3.16724 14.3572 5.25786 14.1976 7.79852C14.0626 9.88914 12.3647 11.587 10.2741 11.722ZM10.1473 9.78277C8.78081 9.86868 7.65163 8.74359 7.74164 7.37712C7.81119 6.24794 8.72763 5.3356 9.85681 5.26195C11.2233 5.17604 12.3525 6.30113 12.2625 7.6676C12.1888 8.80087 11.2724 9.71322 10.1473 9.78277Z"
        fill="currentColor"
      />
      <rect
        x="2.29289"
        y="13.2476"
        width="18.5066"
        height="2.25"
        rx="1.125"
        transform="rotate(-45 2.29289 13.2476)"
        fill="currentColor"
        stroke="white"
      />
    </svg>
  )
})

EyeOff.displayName = 'EyeOff'
